<template>
  <div class="contents mst_syounin_groups">
    <h2>承認グループ編集</h2>

    <loading v-if="isLoading" :message="'データ読み込み中...'"></loading>
    <p v-else-if="!syouninGroupDetail" class="aligncenter">承認グループの詳細取得に失敗しました</p>
    <template v-else>
      <div class="maininfo">
        <div class="tabs">
          <scroll-tabs style="width: 100%">
            <ul>
              <li :class="{ active: tab === 'basic' }"><a @click="tab = 'basic'">基本情報</a></li>
              <li :class="{ active: tab === 'syouninUsers' }"><a
                  @click="tab = 'syouninUsers'">承認者・確認者</a></li>
              <li :class="{ active: tab === 'users' }"><a @click="tab = 'users'">所属するユーザー</a></li>
            </ul>
          </scroll-tabs>
        </div><!-- /tabs -->

        <div class="tab-container">
          <component :is="currentTab" @reload="load" :syouninGroupDetail="syouninGroupDetail" :options="syouninGroupOptions" :tab="tab" />
        </div>

      </div><!-- /maininfo -->
    </template>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.MST_SYOUNIN_GROUP_SEARCH,
        }">戻る
        </router-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref } from 'vue'
import { useTab } from '@/composable/common/tab';
import PartsBasic from './parts/Basic.vue';
import PartsSyouninUsers from './parts/SyouninUsers.vue';
import PartsUsers from './parts/Users.vue';
import { useRoute } from 'vue-router';
import { RouterConst } from '@/const/Router'
import { useSyouninGroupOptions } from '@/composable/master/syounin_group/syounin_group_options';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';

export default defineComponent({
  setup() {
    const route = useRoute();
    const groupId = parseInt(route.params.id as string, 10);
    // 初期化
    const { syouninGroupDetail, getSyouninGroupDetail } = useSyouninGroup();
    const { getAllSyouninGroupOptions, syouninGroupOptions } = useSyouninGroupOptions();

    const isLoading = ref(false)

    onMounted(async () => {
      await load()
    });

    const { tab, currentTab } = useTab('basic');

    const load = async () => {
      isLoading.value = true
      await getAllSyouninGroupOptions()
      await getSyouninGroupDetail(groupId)
      isLoading.value = false

    }

    return {
      syouninGroupDetail,
      syouninGroupOptions,
      isLoading,
      tab,
      currentTab,
      RouterConst,
      load
    }
  },
  components: {
    'parts-basic': PartsBasic,
    'parts-syouninUsers': PartsSyouninUsers,
    'parts-users': PartsUsers,
  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syounin_group_edit.scss";
</style>
